import { useEffect, useState } from "react";
import Model, { helper, Providers } from "@tripian/model";
import { providers } from "@tripian/core";
import moment from "moment";

const useGygCatalog = (
  cityName?: string,
  arrivalDatetime?: string,
  departureDatetime?: string,
  numberOfAdults?: number,
  numberOfChildren?: number | null
) => {
  const [gygToursCatalog, setGygToursCatalog] =
    useState<Providers.Gyg.CatalogGroup[]>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const isGygActive =
    typeof window !== "undefined" &&
    window.tconfig &&
    Array.isArray(window.tconfig.TOUR_TICKET_PROVIDER_IDS)
      ? window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(Model.PROVIDER_ID.GYG)
      : false;
  const [gygLoaders, setGygLoaders] = useState<{ tourCatalogLoader: boolean }>({
    tourCatalogLoader: isGygActive,
  });
  const gygConfig = window.tconfig.PROVIDERS.tourAndTicket.find(
    x => x.id === Model.PROVIDER_ID.GYG
  );

  useEffect(() => {
    if (
      cityName &&
      arrivalDatetime &&
      departureDatetime &&
      numberOfAdults &&
      window.tconfig.SHOW_TOURS_AND_TICKETS
    ) {
      if (
        window.tconfig.TOUR_TICKET_PROVIDER_IDS.some(
          x => x === Model.PROVIDER_ID.GYG
        )
      ) {
        setGygLoaders(prev => ({ ...prev, tourCatalogLoader: true }));
        setErrorMessage(undefined);

        // TODO
        // Temporary solution. Will be removed.
        let cityNameDefault = cityName;
        if (cityName === "Eugene") {
          cityNameDefault = "Oregon/Eugene";
        }

        const cityNameEngChar = helper.toEngChars(cityNameDefault).trim();

        providers.gyg
          ?.toursAll(
            cityNameEngChar,
            undefined,
            undefined,
            {
              start: moment.utc(arrivalDatetime).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment.utc(departureDatetime).format("YYYY-MM-DDTHH:mm:ss"),
            },
            gygConfig?.limit
          )
          .then((tours: Providers.Gyg.CatalogGroup[]) => {
            if (Array.isArray(tours) && tours.length > 0) {
              setGygToursCatalog(tours);
            } else {
              setGygToursCatalog([]);
            }
          })
          .catch(gygFetchToursError => {
            console.error("gygFetchToursError:", gygFetchToursError);
            setGygToursCatalog([]);
            setErrorMessage("Failed to fetch tours. Please try again later.");
          })
          .finally(() => {
            setGygLoaders(prev => ({ ...prev, tourCatalogLoader: false }));
          });
      }
    }
  }, [
    arrivalDatetime,
    cityName,
    departureDatetime,
    gygConfig?.limit,
    numberOfAdults,
    numberOfChildren,
  ]);

  return {
    gygToursCatalog,
    gygLoaders,
    errorMessage,
  };
};

export default useGygCatalog;
